import { JObject } from "../../../../common/data/models";
import { buildFilterMetaToObject, buildSortParamsToString, PaginatedRequestCriteria, PaginatedRequestParams, PaginatedResponse, Result } from "../../../../common/pagination";
import { endpoints } from "../../../../constants/endpoints";
import { DateUtils } from "../../../../helpers/date";
import { tawreedHttpService } from "../../../../http";
import { StatementReportMapper } from "../../../reports/data";
import { ReportResultDto, StatementReportItem } from "../../../reports/domain";
import { CreditDto, TopUpEligibleResultDto, TopupOnboardDto, WalletTransactionDto } from "../../domain/dtos";
import { TopupPartnerDto } from "../../domain/dtos/topup-partner";
import { TopUpEligibleResultMapper, TopupPartnerMapper } from "../mappers";
import { WalletTransactionMapper } from "../mappers/walletTransaction";

export class WalletRepo {

    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<WalletTransactionDto>> {

        const params = {
            sort: request.sort ? buildSortParamsToString(request.sort) : undefined,
            page: request.page,
            size: request.size,
        };
        const data = { ...buildFilterMetaToObject(request.keyword, { ...request.filters }) };
        return tawreedHttpService.post<JObject, Result<JObject>>(endpoints.WALLET_TRANSACTION_SEARCH, data, params, undefined, 'error')
            .then(res => {
                return {
                    ...res!,
                    data: { ...res!.data!, content: res!.data!.content.map(e => WalletTransactionMapper.fromJson(e)) ?? [] },
                };
            });
    }

    public async getDetails(id: number): Promise<WalletTransactionDto> {
        return tawreedHttpService.post<number, JObject>(endpoints.WALLET_TRANSACTION_DETAILS, id, undefined, undefined, 'error').then(res => WalletTransactionMapper.fromJson(res.data!));
    }

    public searchTopupPartners(request: PaginatedRequestParams): Promise<PaginatedResponse<TopupPartnerDto>> {

        const params = {
            sort: request.sort ? buildSortParamsToString(request.sort) : undefined,
            page: request.page,
            size: request.size,
        };
        const data = { ...buildFilterMetaToObject(request.keyword, { ...request.filters }) };
        return tawreedHttpService.post<JObject, Result<JObject>>(endpoints.TOPUP_PARTNEER_SEARCH, data, params, undefined, 'error')
            .then(res => {
                return {
                    ...res!,
                    data: { ...res!.data!, content: res!.data!.content.map(e => TopupPartnerMapper.toDto(e)) ?? [] },
                };
            });
    }

    public checkEligible(req: CreditDto): Promise<TopUpEligibleResultDto> {
        return tawreedHttpService.post<JObject, JObject>(endpoints.TOPUP_PARTNEER_ELIGIBLE, {
            amount: req.amount,
            topUpPartnerId: req.topUpPartner?.topUpPartnerId
        }, undefined, undefined, 'error').then(res => TopUpEligibleResultMapper.toDto(res.data!, res.message!));
    }
    public requestTopup(req: CreditDto): Promise<TopUpEligibleResultDto> {
        return tawreedHttpService.post<JObject, JObject>(endpoints.TOPUP_PARTNEER_REQUEST, {
            amount: req.amount,
            topUpPartnerId: req.topUpPartner?.topUpPartnerId
        }, undefined, undefined, 'error').then(res => TopUpEligibleResultMapper.toDto(res.data!, res.message!));
    }
    public confirmTopup(req: CreditDto): Promise<boolean> {
        return tawreedHttpService.post<JObject, boolean>(endpoints.TOPUP_PARTNEER_CONFIRM, {
            amount: req.amount,
            topUpPartnerId: req.topUpPartner?.topUpPartnerId,
            otp: req.otp
        }, undefined, undefined, 'error').then(res => res.data!);
    }

    public createOrUpdate(dto: TopupOnboardDto): Promise<boolean> {
        return tawreedHttpService.post<JObject, JObject>(endpoints.TOPUP_PARTNER_ONBOARD, dto, undefined, undefined, 'error')
            .then(res => {
                if(res && res.data){
                    return res.data.status
                }
                return false;
            });
    }

    public getWalletInfo(scale: number): Promise<ReportResultDto<StatementReportItem>> {
        const params = {
            sort: undefined,
            page: 0,
            size: 15,
        };
        const data = {
            partnerId: 123,
            startDate: null,
            endDate: DateUtils.beforNow(1).toISOString()
        };

        return tawreedHttpService.post<JObject, JObject>(endpoints.REPORTS_STATEMENTS_FETCH, data, params, undefined, 'error')
            .then((res) => {
                if (!res || !res.data) {
                    return Promise.reject(null);
                }
                return StatementReportMapper.fromJson(res.data, scale, 0);
            });
    }
	protected fromRequestParamsToJObject(req: PaginatedRequestParams) {
    
            const ee = buildFilterMetaToObject(req.keyword, req.filters);
            if (!ee || !ee.criteria) {
                return {};
            }
            const ans1: PaginatedRequestCriteria[] = ee.criteria;
            const ans2: any = {};
            ans1.forEach(e => {
                //
                if (ans2[e.fieldName]) {
                    console.warn('overrwite', e);
                }
                ans2[e.fieldName] = e.value;
            });
    
            return ans2;
        }
	
}
